export default "/images/86a26d139a5fe4723ab54cd6c1c26534.avif";